import * as React from 'react';

function SvgProgressStop(props) {
  return (
    <svg width={18} height={18} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M9 1.125a7.876 7.876 0 10.001 15.751A7.876 7.876 0 009 1.125zm0 14.414A6.54 6.54 0 013.929 4.873l9.198 9.198A6.51 6.51 0 019 15.54zm5.071-2.412L4.873 3.93a6.54 6.54 0 019.199 9.199z"
        fill="#38B2A6"
      />
    </svg>
  );
}

export default SvgProgressStop;
